import './BetaTag.css'

export function BetaTag() {
  return <span className="beta-tag">BETA</span>
}
